import { render, staticRenderFns } from "./layout3.vue?vue&type=template&id=0f456b0a&scoped=true&"
import script from "./layout3.vue?vue&type=script&lang=js&"
export * from "./layout3.vue?vue&type=script&lang=js&"
import style0 from "./layout3.vue?vue&type=style&index=0&id=0f456b0a&prod&lang=scss&scoped=true&"
import style1 from "./layout3.vue?vue&type=style&index=1&id=0f456b0a&prod&lang=scss&"
import style2 from "./layout3.vue?vue&type=style&index=2&id=0f456b0a&prod&scoped=true&lang=css&"
import style3 from "./layout3.vue?vue&type=style&index=3&id=0f456b0a&prod&lang=css&"
import style4 from "./layout3.vue?vue&type=style&index=4&id=0f456b0a&prod&lang=scss&"
import style5 from "./layout3.vue?vue&type=style&index=5&id=0f456b0a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f456b0a",
  null
  
)

export default component.exports